import React from 'react';
import {ProductionPatternItem, ProductionPatternTag} from '../content/types';
import QueryCopyButton from './QueryCopyButton';

const TAG_LABELS: Record<ProductionPatternTag, string> = {
    'phrase-bank': 'phrase bank',
    exclusions: 'exclusions',
    proximity: 'proximity',
    'dual-strategy': 'dual strategy',
    'product-variants': 'product variants',
    'multi-branch': 'multi-branch',
    'wildcard-stems': 'wildcard stems',
    'loose-boolean': 'loose boolean',
};

interface Props {
    item: ProductionPatternItem;
}

const QueryPatternCard = React.memo<Props>(({item}) => (
    <article className="query-help-modal__pattern-card">
        <div className="query-help-modal__sample-card-header">
            <h4 className="query-help-modal__sample-card-title">{item.title}</h4>
            {item.query ? <QueryCopyButton query={item.query} /> : null}
        </div>

        {item.tags?.length ? (
            <div className="query-help-modal__pattern-tags">
                {item.tags.map((tag) => (
                    <span key={tag} className="query-help-modal__pattern-tag">
                        {TAG_LABELS[tag]}
                    </span>
                ))}
            </div>
        ) : null}

        {item.structure ? (
            <p className="query-help-modal__pattern-structure">
                <span className="query-help-modal__pattern-label">Structure:</span>
                {' '}
                <code>{item.structure}</code>
            </p>
        ) : null}

        {item.query ? (
            <pre className="query-help-modal__query-block">{item.query}</pre>
        ) : null}

        {item.whenToUse ? (
            <p className="query-help-modal__sample-description">
                <span className="query-help-modal__pattern-label">When to use:</span>
                {' '}
                {item.whenToUse}
            </p>
        ) : null}

        {item.description ? (
            <p className="query-help-modal__sample-description">{item.description}</p>
        ) : null}

        {item.productionNote ? (
            <p className="query-help-modal__pattern-note">
                <span className="query-help-modal__pattern-label">Production:</span>
                {' '}
                {item.productionNote}
            </p>
        ) : null}
    </article>
));

export default QueryPatternCard;
